import { humanDate } from "./humanDate";
import { lang, placeholder } from "./../app";

export const getAssetMap = (assets, metaFields) => {
	let displayNameKey = `newsroomDisplayName${lang === "en" ? "" : lang.toUpperCase()}`;
	let assetMap = {};
	metaFields.forEach(field => {
		assetMap[Object.keys(field)[0]] = [];
	});
	// assetMap will hold assets keyed
	// by our important meta fields

	assets.forEach(asset => {
		let type = asset.metadata.fields.newsroomAssetType ? asset.metadata.fields.newsroomAssetType.join(",") : asset.file_properties && asset.file_properties.format_type ? asset.file_properties.format_type : null;
		let _asset = {
			filename: asset.filename,
			name: asset.metadata.fields[displayNameKey] && asset.metadata.fields[displayNameKey].length ? asset.metadata.fields[displayNameKey][0] : asset.metadata.fields.newsroomDisplayName ? asset.metadata.fields.newsroomDisplayName[0] : asset.filename,
			type: type,
			size: asset.file_properties && asset.file_properties.size_in_kbytes ? asset.file_properties.size_in_kbytes : null,
			created: humanDate(asset.created_date),
			src: "DAM",
			external_id: asset.external_id,
			uuid: asset.id,
			thumb: type && type.toLowerCase() === "video" && asset.embeds && asset.embeds.video_poster ? asset.embeds.video_poster.url : asset.thumbnails && asset.thumbnails["2048px"] ? asset.thumbnails["2048px"].url : placeholder,
			cart_thumb: asset.thumbnails && asset.thumbnails["300px"] ? asset.thumbnails["300px"].url : placeholder
		};
		if (asset.embeds && asset.embeds.video_player) {
			_asset.video = Object.assign(_asset.video ? _asset.video : {}, {
				player: asset.embeds.video_player,
				duration: asset.file_properties && asset.file_properties.video_properties && asset.file_properties.video_properties.duration ? asset.file_properties.video_properties.duration : null
			});
			// if a video player exists, include it

			_asset.url = asset.embeds && asset.embeds.original && asset.embeds.original.url ? asset.embeds.original.url : null;
			// _asset.url = asset.embeds ? (asset.embeds.original && asset.embeds.original.url ? asset.embeds.original.url : asset.embeds.video_player_with_download && asset.embeds.video_player_with_download.url ? asset.embeds.video_player_with_download.url : asset.embeds.VideoWithPlayerAndDownload && asset.embeds.VideoWithPlayerAndDownload.url ? asset.embeds.VideoWithPlayerAndDownload.url : null) : null;
			// also, use the video_player urls for download link, preferring "original" if available
		} else if (asset.embeds && (asset.embeds.document_html5_viewer || asset.embeds.document_viewer)) {
			_asset.document = Object.assign(_asset.document ? _asset.document : {}, {
				viewer: asset.embeds.document_html5_viewer ? asset.embeds.document_html5_viewer : asset.embeds.document_viewer
			});
			// if a document viewer exists, include it,
			// preferring the html5 version;

			_asset.url = asset.embeds ? (asset.embeds.original && asset.embeds.original.url ? asset.embeds.original.url : asset.document_html5_viewer && asset.document_html5_viewer.url ? asset.document_html5_viewer.url : asset.document_viewer_with_download && asset.document_viewer_with_download.url ? asset.document_viewer_with_download.url : asset.document_viewer && asset.document_viewer.url ? asset.document_viewer.url : null) : null;
		}
		// use the one of the document viewer URLs as the url for downloads
		else {
			_asset.url = asset.embeds && asset.embeds.original ? asset.embeds.original.url : asset.embeds.OriginalSize ? asset.embeds.OriginalSize.url : placeholder;
			// for everything else (ie, images),
			// use the embeds.OriginalSize as the url
		}

		metaFields.forEach(metaField => {
			let field = Object.keys(metaField)[0];
			if (asset.metadata.fields[field] && asset.metadata.fields[field].length) {
				let values = asset.metadata.fields[field];
				// values is now the array on the asset
				// containing values for this field
				values.forEach(value => {
					// e.g. for field 'model',
					// values could be 'g280','g650' etc
					// and value for values would be
					// an array of assets
					let __asset = Object.assign(
						{
							locator: {
								field: field,
								value: value
							}
						},
						_asset
					);
					// let's provide a map to this asset's
					// location (as a copy, not a reference)
					// in assetMaps it can
					// carry with it;
					if (assetMap[field][value]) {
						assetMap[field][value].push(__asset);
					} else {
						assetMap[field][value] = [__asset];
					}
				});
			}
		});
	});
	// assetMap now has values as keys
	// for each field name, with pared-
	// down object for assets matching that value
	return assetMap;
};
// end getAssetMap function
